module.exports = __webpack_public_path__ + "static/media/oAuth-MS.6bad9767.svg";